import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const ModalError = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const interviewText = t("Do you want to visualize the last ");
  const precandidateText = t("Do you want to visualize the existing ");
  
  function openPrecandidateDetails(event, precandidateId) {
    props.closeModalError();
    props.setModalShow(false);
    props.openDeletePreCandidateModal(event, precandidateId);
  }

  function gotoInterview(interviewId) {
    history.push(`/interview/view/${interviewId}`);
  }
  
  return (
    <>
      <div
        class={`modal fade ${props.modalErrorOpen && "show"}`}
        id="exampleModal"
        tabindex="-10"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{
          display: props.modalErrorOpen ? "block" : "none",
          zIndex: 9999
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content alert-shadow">
            <div className="modal-header">
              <h5 className="modal-title text-danger" id="exampleModalLabel">
                {t("Error")}
              </h5>
            </div>
            <div className="modal-body">
              <div className="text-danger">
                {" "}
                {t("Pre-candidate already exists.")}
              </div>
              {props.modalErrorRedirect?.interviewId ? interviewText : ""}
              {props.modalErrorRedirect?.interviewId && (
                <a
                  href="#1"
                  onClick={() =>
                    gotoInterview(props.modalErrorRedirect.interviewId)
                  }
                >
                  {" "}
                  {t("Interview")}
                </a>
              )}
              {props.modalErrorRedirect?.precandidateId && !props.modalErrorRedirect?.interviewId ? precandidateText : ""}
              {props.modalErrorRedirect?.precandidateId && !props.modalErrorRedirect?.interviewId && (
                <a
                  href="#1"
                  onClick={(event) =>
                    openPrecandidateDetails(
                      event,
                      props.modalErrorRedirect.precandidateId
                    )
                  }
                >
                  {t("pre-candidate")}
                </a>
              )}
            </div>
            <div className="modal-footer">
              <button
                className="app-button btn-prime btn-lg"
                type="button"
                data-bs-dismiss="modal"
                onClick={props.closeModalError}
              >
                {t("Close")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalError;
